<template>
    <Head title="Mon profile" />

    <AppLayout>
        <main>
            <ProfileUser link-updade-profile="profile.update" />
        </main>
    </AppLayout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout.vue'
    import { Head } from '@inertiajs/inertia-vue3';
    import ProfileUser from '@/Components/ProfileUser.vue'

    export default {
        components: {
            Head,
            AppLayout,
            ProfileUser
        }
    }
</script>
